import { TimelineLite } from "gsap";
import * as HLF from "html-living-framework";
import * as Constants from "../Data/Constants";
import { PatchStitch } from "../GameObjects/PatchStitch";
import * as QuiltUtils from "../Utils/QuiltUtils";

export class PatchBorder extends PIXI.Container {
    private static STITCH_SPACING_MIN: number = 10;

    private _outline: PIXI.Sprite;
    private _stiches: PatchStitch[];

    constructor(pDir: QuiltUtils.Direction) {
        super();

        this._outline = HLF.PixiUtils.makeSprite("border", Constants.SPRITESHEET_QUILT_PREFIX + "01");
        this._outline.width = QuiltUtils.TILE_WIDTH + this._outline.height;
        this._outline.anchor.set(0.5, 0.5);
        this.addChild(this._outline);

        this._stiches = new Array<PatchStitch>(HLF.Random.intBetween(2, 5));
        // TODO:SH: Clean up these calculations
        const stitchWindow: number = (
                QuiltUtils.TILE_WIDTH -
                (this._stiches.length + 1) *
                PatchBorder.STITCH_SPACING_MIN
            ) / this._stiches.length;
        for (let i = 0; i < this._stiches.length; ++i) {
            this._stiches[i] = new PatchStitch();
            this._stiches[i].position.x =
                PatchBorder.STITCH_SPACING_MIN * (1 + i) +
                i * stitchWindow +
                (Math.random() * stitchWindow) -
                (QuiltUtils.TILE_WIDTH * 0.5);
            this.addChild(this._stiches[i]);
        }
        this.hideStitches();

        this.rotation = -Math.atan2(QuiltUtils.DIR_OFFSET[pDir].y, QuiltUtils.DIR_OFFSET[pDir].x) + Math.PI * 0.5;
        this.position.set(
            (QuiltUtils.DIR_ORIGIN[pDir].x) * QuiltUtils.TILE_WIDTH,
            (QuiltUtils.DIR_ORIGIN[pDir].y) * QuiltUtils.TILE_WIDTH,
        );
    }

    public showStitches(): void {
        const timeline: TimelineLite = new TimelineLite();
        for (let i = 0; i < this._stiches.length; ++i) {
            const index: number = i;
            timeline.add(() => {
                this._stiches[index].show();
            }, HLF.Random.floatBetween(0, 0.25));
        }
    }

    public hideStitches(): void {
        for (let i = 0; i < this._stiches.length; ++i) {
            this._stiches[i].hide();
        }
    }
}
